module.exports = __webpack_public_path__ + "static/media/Password-sent.1d1379a8.png";